import { createApp, h } from 'vue'
import i18n from '@/i18n'
import AppEduBindPhone from './AppEduBindPhone.vue'
interface ChangePasswordOptions {
  canClose?: boolean
  cancel?: () => void
  onSuccess?: (data: any) => void
  validateAuthToken?: string //临时token
}

export type ChangePasswordType = (options: ChangePasswordOptions) => void

let appInstance: any = null
let app: ReturnType<typeof createApp> | null = null
const destroyApp = () => {
  // 从 DOM 中移除实例
  app?.unmount()
  appInstance = null

  // 移除临时的 div
  const div = document.querySelector('#app-bindPhone')
  if (div) {
    document.body.removeChild(div)
  }
}
const BindPhoneService = (options: ChangePasswordOptions) => {
  options.canClose = options.canClose ?? true
  // 如果已存在实例，先销毁
  if (appInstance) {
    destroyApp()
  }

  app = createApp({
    render() {
      return h(AppEduBindPhone, {
        ...options,
        onClose: () => {
          if (!options.canClose) return
          destroyApp()
          options.cancel?.()
        },
        onOk: (data: any) => {
          window.isLoggedIn = true
          // 确保回调在组件销毁后执行
          setTimeout(() => {
            options.onSuccess?.(data)
          }, 0)
          destroyApp()
        }
      })
    }
  })

  const div = document.createElement('div')
  div.id = 'app-bindPhone'
  document.body.appendChild(div)
  appInstance = app.use(i18n).mount(div)
}

export default BindPhoneService
